import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["observedWaypoints", "optionOverrides"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */
import { useComponent } from '@uswitch/ev-utils/context/selectors';
import { toKebabCase } from '@uswitch/ev-utils/string';
import { Type } from '@uswitch/spark.type';
import { Themed } from 'theme-ui';
import { BLOCKS as B, INLINES as I, MARKS as M } from '@contentful/rich-text-types';
import { LinkWithChevron as Link, Palette } from '@uswitch/ev-core/react';
import Filter from '../helpers/filtered';
import { moduleEntity } from '../helpers/modules';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var paletteHeading = function paletteHeading(as) {
  return function (node, text) {
    return _jsx(Palette, {
      as: as,
      px: {
        color: function color(palette) {
          return palette.headingColor || palette.textColor;
        }
      },
      id: toKebabCase(documentToPlainTextString(node) || ''),
      children: text
    });
  };
};

export var Options = function Options() {
  var _objectSpread2, _objectSpread3;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var observedWaypoints = config.observedWaypoints,
      _config$optionOverrid = config.optionOverrides,
      optionOverrides = _config$optionOverrid === void 0 ? {
    renderMark: {},
    renderNode: {}
  } : _config$optionOverrid,
      extraData = _objectWithoutProperties(config, _excluded);

  var out = {
    renderMark: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, M.BOLD, function (text) {
      return _jsx("b", {
        children: text
      });
    }), _defineProperty(_objectSpread2, M.ITALIC, function (text) {
      return _jsx("i", {
        children: text
      });
    }), _defineProperty(_objectSpread2, M.UNDERLINE, function (text) {
      return _jsx("span", {
        sx: {
          textDecoration: 'underline'
        },
        children: text
      });
    }), _defineProperty(_objectSpread2, M.CODE, function (text) {
      return _jsx(Themed.strong, {
        children: text
      });
    }), _objectSpread2), optionOverrides.renderMark),
    renderNode: _objectSpread((_objectSpread3 = {}, _defineProperty(_objectSpread3, B.EMBEDDED_ASSET, function (node) {
      return moduleEntity(node.data.target, _objectSpread(_objectSpread({}, extraData), {}, {
        spacing: node.spacing,
        tag: 'embeddedAsset'
      }));
    }), _defineProperty(_objectSpread3, B.EMBEDDED_ENTRY, function (node) {
      return moduleEntity(node.data.target, extraData);
    }), _defineProperty(_objectSpread3, B.HEADING_1, paletteHeading(Type.H1)), _defineProperty(_objectSpread3, B.HEADING_2, function (node, text) {
      var id = toKebabCase(documentToPlainTextString(node) || '');
      return _jsx(Palette, _objectSpread(_objectSpread({
        as: Type.H2,
        px: {
          color: function color(palette) {
            return palette.headingColor || palette.textColor;
          }
        }
      }, observedWaypoints && observedWaypoints[id] ? {
        ref: observedWaypoints[id][1]
      } : {}), {}, {
        id: id,
        children: text
      }));
    }), _defineProperty(_objectSpread3, B.HEADING_3, paletteHeading(Type.H3)), _defineProperty(_objectSpread3, B.HEADING_4, paletteHeading(Type.H4)), _defineProperty(_objectSpread3, B.HEADING_5, paletteHeading(Type.H5)), _defineProperty(_objectSpread3, B.HEADING_6, paletteHeading(Type.H6)), _defineProperty(_objectSpread3, B.HR, function () {
      return _jsx(Themed.hr, {});
    }), _defineProperty(_objectSpread3, B.UL_LIST, function (_, text) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var _useComponent = useComponent({
        tag: 'list'
      }),
          _useComponent2 = _slicedToArray(_useComponent, 2),
          List = _useComponent2[1];

      return _jsx(List, {
        listType: "bullet",
        children: text
      });
    }), _defineProperty(_objectSpread3, B.OL_LIST, function (_, text) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var _useComponent3 = useComponent({
        tag: 'list'
      }),
          _useComponent4 = _slicedToArray(_useComponent3, 2),
          List = _useComponent4[1];

      return _jsx(List, {
        listType: "numeric",
        children: text
      });
    }), _defineProperty(_objectSpread3, B.LIST_ITEM, function (_, text) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      var _useComponent5 = useComponent({
        tag: 'listItem'
      }),
          _useComponent6 = _slicedToArray(_useComponent5, 2),
          ListItem = _useComponent6[1];

      return _jsx(ListItem, {
        children: text
      });
    }), _defineProperty(_objectSpread3, I.HYPERLINK, function (node, text) {
      return _jsx(Filter, {
        when: text.join('').length,
        children: _jsx(Link, _objectSpread(_objectSpread({}, extraData), {}, {
          href: node.data.uri,
          children: text
        }))
      });
    }), _defineProperty(_objectSpread3, B.PARAGRAPH, function (node, text) {
      return _jsx(Filter, {
        when: text.join('').length,
        children: _jsx(Palette, {
          as: "p",
          sx: {
            variant: 'styles.p'
          },
          px: {
            color: 'textColor'
          },
          children: text.map(function (content, i) {
            return [content, typeof content === 'string' && content.endsWith('\n') ? _jsx("br", {}, "1") : null];
          }, this)
        })
      });
    }), _defineProperty(_objectSpread3, B.QUOTE, function (node, text) {
      return _jsx(Themed.blockquote, {
        children: text
      });
    }), _objectSpread3), optionOverrides.renderNode)
  };
  return out;
};
export default Options;
//# sourceMappingURL=options.js.map